// extracted by mini-css-extract-plugin
export default {"textfield":"appidfield_textfield__a2k6I","appIdField":"appidfield_appIdField__gKCxa","wrapper":"appidfield_wrapper__8iJ2P","appIdText":"appidfield_appIdText__Phcg+"};